import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Tab, Nav } from "react-bootstrap";
import config from "../../../../config.json";
import PageTitle from "../../layouts/PageTitle";
import imgVide from "../../../assets/images/vide.png";

import { getMenuLanguages } from "../../../constants/menuLanguages";
import "../../../i18n";
import { useTranslation } from "react-i18next";

const MenuDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [menuDetails, setMenuDetails] = useState({});
  const [globalDetails, setGlobalDetails] = useState({ photo: null });
  const [activeLang, setActiveLang] = useState("en");
  const [restaurantId, setRestaurantId] = useState();
  const languages = getMenuLanguages(t);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await axios.get(`${config.dev}/V2/menu/getById/${id}`);
        const menu = response.data;

        setRestaurantId(menu.restaurantId.restaurantFK);
        const details = {};
        languages.forEach((lang) => {
          const langData = menu.menuDetails.find(
            (d) => d.language === lang.code
          );
          details[lang.code] = { menuName: langData?.menuName || "" };
        });
        setMenuDetails(details);

        setGlobalDetails({ photo: menu.photo || null });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching menu:", error);
        setLoading(false);
      }
    };

    fetchMenu();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  const imgMenu = globalDetails?.photo
    ? `${config.UPLOADS_SERVER}/menu/${globalDetails.photo}`
    : imgVide;
  return (
    <div className="row">
      <div className="col-12 d-flex justify-content-between align-items-center mb-3">
        <PageTitle activeMenu={t("menuDetails")} motherMenu={t("kitchen")} />

        <button
          style={{
            backgroundColor: "#FA8072", // saumon
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "20px",
            cursor: "pointer",
          }}
          className="btn btn-success"
          onClick={() =>
            window.open(`${config.client}/${restaurantId}`, "_blank")
          }
        >
          {t("viewMenuAsCustomer")}
        </button>
      </div>

      {/* IMAGE */}
      <div className="col-lg-3">
        <div className="d-flex flex-column align-items-center mt-3">
          <img
            src={imgMenu}
            alt="Menu"
            className="img-fluid"
            style={{
              width: "200px",
              height: "200px",
              objectFit: "cover",
              borderRadius: "20px",
            }}
          />
        </div>
      </div>

      {/* DETAILS */}
      <div className="col-9">
        <Tab.Container defaultActiveKey={activeLang}>
          <Nav as="ul" className="nav-tabs">
            {languages.map((lang) => (
              <Nav.Item as="li" key={lang.code}>
                <Nav.Link
                  eventKey={lang.code}
                  onClick={() => setActiveLang(lang.code)}
                >
                  <img width={25} src={lang.flag} alt={lang.label} />
                  &nbsp; {lang.label}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          <Tab.Content className="pt-4">
            {languages.map((lang) => (
              <Tab.Pane eventKey={lang.code} key={lang.code}>
                {t("title")}
                <input
                  type="text"
                  className="form-control"
                  value={menuDetails[lang.code]?.menuName}
                  readOnly
                  style={{ marginBottom: 10 }}
                />
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>

      </div>
    </div>
  );
};

export default MenuDetails;
